import { useDispatch, useSelector } from 'react-redux';
import { SET_OPEN_WELCOME_DIALOG } from '../../redux/features/theme/extradialogs';
import { Dialog, DialogContent, DialogOverlay } from '@/components/ui/dialog';
// import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
import { useEffect, useState } from 'react';
// import tokenBanner from '../../assets/TokenBanner.jpg';

const WelcomeDialog = () => {
    const dispatch = useDispatch();
    const { isOpenWelcomeDialog, isOpenGamifyDialog } = useSelector((state) => state.extradialogs);
    const [animateGlow, setAnimateGlow] = useState(false);

    const handleClose = () => {
        dispatch(SET_OPEN_WELCOME_DIALOG(false));
    };

    useEffect(() => {
        const today = new Date().toDateString();
        const lastWelcomeOpen = localStorage.getItem('lastWelcomeOpen');

        if (!lastWelcomeOpen) {
            dispatch(SET_OPEN_WELCOME_DIALOG(true));
            if (!isOpenGamifyDialog) {
                dispatch(SET_OPEN_WELCOME_DIALOG(true));
            }
            localStorage.setItem('lastWelcomeOpen', today);
            return;
        }

        const lastOpenDate = new Date(lastWelcomeOpen);
        const daysSinceLastOpen = Math.floor((new Date() - lastOpenDate) / (1000 * 60 * 60 * 24));

        if (daysSinceLastOpen >= 1) {
            if (!isOpenGamifyDialog) {
                dispatch(SET_OPEN_WELCOME_DIALOG(true));
            }
            localStorage.setItem('lastWelcomeOpen', today);
        }
    }, [dispatch, isOpenGamifyDialog]);

    useEffect(() => {
        // Start pulsing animation
        const interval = setInterval(() => {
            setAnimateGlow(prev => !prev);
        }, 1500);

        return () => clearInterval(interval);
    }, []);

    return (
        <Dialog open={isOpenWelcomeDialog && !isOpenGamifyDialog} onOpenChange={handleClose}>
            <DialogOverlay className="z-[999] bg-black/80 backdrop-blur-sm">
                <DialogContent className="md:w-[90%] lg:w-[80%] w-[95%] max-w-6xl h-auto max-h-[90vh] overflow-y-auto border border-green-500/30 shadow-2xl shadow-green-500/20 bg-gradient-to-br from-black via-slate-950 to-slate-900 z-[9999] rounded-xl animate-fadeIn">
                    {/* Animated background dots/grid */}
                    <div className="absolute inset-0 overflow-hidden rounded-xl">
                        <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(66,255,0,0.15),transparent_70%)] animate-pulse"></div>
                        <div className="absolute w-full h-full bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj48Y2lyY2xlIGZpbGwtb3BhY2l0eT0iLjIiIGZpbGw9IiM0MkZGMDAiIGN4PSIxMCIgY3k9IjEwIiByPSIxIi8+PC9nPjwvc3ZnPg==')]"></div>
                    </div>
                    <a href="https://x.com/SoundOfMemeSol" target="_blank" rel="noopener noreferrer" className="w-full h-full overflow-hidden">
                        <div className="relative w-full h-full z-10">
                            <div className="w-full h-full flex flex-col items-center justify-center">
                                <div className="w-full max-w-3xl p-0 md:p-8 flex flex-col justify-center">
                                    <div className="space-y-3 md:space-y-5">
                                        <div className="relative">
                                            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-black text-white leading-tight tracking-tight">
                                                JOIN US <span className="animate-pulse">THIS</span> FRIDAY
                                            </h1>
                                            <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-black text-white leading-tight tracking-tight">
                                                ON <span className="inline-flex items-center">X<span className="ml-2 bg-white w-3 h-3 sm:w-4 sm:h-4 rounded-full inline-block"></span></span> LIVE FOR A
                                            </h2>
                                            <div className="mt-2 relative">
                                                <span className={`text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-black text-transparent bg-clip-text bg-gradient-to-r from-green-400 to-green-300 leading-tight tracking-tight ${animateGlow ? 'drop-shadow-[0_0_15px_rgba(66,255,0,0.7)]' : ''} transition-all duration-1000`}>
                                                    TOKEN GIVEAWAY!
                                                </span>
                                                <div className="absolute -bottom-1 left-0 w-full h-1 bg-gradient-to-r from-green-400 to-transparent"></div>
                                            </div>
                                        </div>

                                        <div className="bg-gradient-to-r from-black via-black to-black/80 border border-green-500/20 p-4 sm:p-5 rounded-lg my-4 sm:my-6 transform hover:scale-105 transition-transform duration-300 shadow-lg shadow-green-900/20 backdrop-blur-sm">
                                            <div className="space-y-2 sm:space-y-3">
                                                <div className="text-lg sm:text-xl md:text-2xl text-white flex items-center">
                                                    <span className="w-8 sm:w-10 text-green-400 opacity-80">📅</span>
                                                    <span className="font-medium">Date:</span>
                                                    <span className="ml-2 font-semibold text-green-300">10th May, 2025</span>
                                                </div>
                                                <div className="text-lg sm:text-xl md:text-2xl text-white flex items-center">
                                                    <span className="w-8 sm:w-10 text-green-400 opacity-80">🕐</span>
                                                    <span className="font-medium">Time:</span>
                                                    <span className="ml-2 font-semibold text-green-300">10PM IST</span>
                                                </div>
                                                <div className="text-lg sm:text-xl md:text-2xl text-white flex items-center">
                                                    <span className="w-8 sm:w-10 text-green-400 opacity-80">📍</span>
                                                    <span className="font-medium">Where:</span>
                                                    <a href="https://x.com/SoundOfMemeSol" target="_blank" rel="noopener noreferrer" className="ml-2 font-semibold text-green-300 hover:text-green-200 hover:underline">@SoundofMemeSol</a>
                                                </div>
                                            </div>
                                        </div>

                                        <p className="text-lg sm:text-xl md:text-2xl lg:text-3xl text-white font-medium pt-2">
                                            Win the giveaway and get the token
                                            <br />straight into your <span className="font-bold bg-gradient-to-r from-green-400 to-green-300 text-transparent bg-clip-text">SOLANA WALLET.</span>
                                        </p>

                                        <div className="pt-3 sm:pt-5 flex justify-center sm:justify-start">
                                            <a
                                                href="https://x.com/SoundOfMemeSol"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="group relative inline-flex items-center justify-center px-6 sm:px-8 py-3 sm:py-4 overflow-hidden font-bold rounded-lg bg-gradient-to-br from-green-500 to-green-400 text-black text-base sm:text-lg transition-all duration-300 ease-out hover:scale-105 hover:from-green-400 hover:to-green-300 shadow-lg shadow-green-500/30"
                                            >
                                                <span className="absolute inset-0 w-full h-full -mt-1 rounded-lg opacity-30 bg-gradient-to-b from-transparent via-transparent to-black"></span>
                                                <span className="relative flex items-center gap-2">
                                                    Follow us on X
                                                </span>
                                                <span className="absolute bottom-0 right-0 w-10 h-10 sm:w-12 sm:h-12 -mb-6 -mr-6 sm:-mb-8 sm:-mr-8 transition-all duration-700 ease-out transform rotate-45 translate-x-1 bg-white opacity-10 group-hover:translate-x-0"></span>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Floating particles */}
                            <div className="absolute top-10 left-10 w-2 h-2 rounded-full bg-green-400/40 animate-float1"></div>
                            <div className="absolute top-40 right-20 w-3 h-3 rounded-full bg-green-400/30 animate-float2"></div>
                            <div className="absolute bottom-20 left-1/4 w-2 h-2 rounded-full bg-green-400/50 animate-float3"></div>
                        </div>
                    </a>
                </DialogContent>
            </DialogOverlay>
        </Dialog>
    );
};

export default WelcomeDialog;